"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _ykbStyledComponents = require("../ykb-styled-components");
var _StyledInputGroup = require("./styled/StyledInputGroup");
var InputGroup = function InputGroup(props) {
  return /*#__PURE__*/_react.default.createElement(_ykbStyledComponents.ThemeConsumer, null, function (theme) {
    return /*#__PURE__*/_react.default.createElement(_StyledInputGroup.StyledInputGroup, (0, _extends2.default)({}, props, {
      theme: theme
    }));
  });
};
var _default = exports.default = InputGroup;